/**
*@title 일정 안내
*@date 2022-02-09
*@author 홍수희
*@desc
*@etc(change)
*/

import React from 'react';
import { t } from 'i18next';

import unist_logo from '../../images_logos/unist_logo.svg';
import ulsan_logo from '../../images_logos/ulsan_logo.svg';
import ueco_logo from '../../images_logos/ueco_logo.svg';

import expo_overview from "../../images/exhibition_overview_1.svg";
import expo_overview_en from "../../images/exhibition_overview_1_en.svg";

const ExhibitionOverview = () => {
    return(
        <div className="sect-01-box-01-schedule">
            <div className='text-center'>
                <div className='inline-block w-full md:w-10/12 max-w-5xl'>
                {t("lang") === "ko"
                    ?<img src={expo_overview} />
                    :<img src={expo_overview_en} />
                }    
                </div>                
            </div>

            {/* <div className="sect-03-tbl-exh-overview"> */}
                
                
                {/*<table>
                    <colgroup>
                        <col width="38%"/>
                        <col width="10%"/>
                        <col width="20%"/>
                        <col width="20%"/>
                        <col width="10%"/>
                        <col width="20%"/>
                        <col width="20%"/>
                    </colgroup>
                    <tbody>
                    <tr>
                        <td>{t("exh_overview_comp1_title")}</td>
                        <td colSpan="5">{t("exh_overview_comp1_content")}</td>
                    </tr>
                    <tr>
                        <td>{t("exh_overview_comp2_title")}</td>
                        <td colSpan="2">{t("exh_overview_comp2_content")}</td>
                        <td>{t("exh_overview_comp3_title")}</td>
                        <th>
                            <div className='img-container-exh-overview'>
                                <img src={ueco_logo} />
                            </div>
                        </th>
                        <td>
                            <div className='txt-container-exh-overview'>
                                {t("exh_overview_comp3_content")}
                            </div>
                        </td>
                    </tr>
                    <tr>
                        <td>{t("exh_overview_comp4_title")}</td>
                        <td colSpan="5">{t("exh_overview_comp4_content1")}<br/>{t("exh_overview_comp4_content2")}</td>
                    </tr>
                    <tr>
                        <td>{t("exh_overview_comp5_title")}</td>
                        <th>
                            <div className='img-container-exh-overview'>
                                <img src={ulsan_logo} />
                            </div>
                        </th>
                        <td>
                            <div className='txt-container-exh-overview'>
                                {t("exh_overview_comp5_content")}
                            </div>
                        </td>
                        <td>{t("exh_overview_comp6_title")}</td>
                        <th>
                            <div className='img-container-exh-overview2'>
                                <img src={unist_logo} />
                            </div>
                        </th>
                        <td>
                            <div className='txt-container-exh-overview'>
                                {t("exh_overview_comp6_content")}
                            </div>
                        </td>
                    </tr>
                    </tbody>
                </table>*/}
                {/* <script>
                    document.getElementById('id1').style.backgroundColor='#003F87';
                </script> */}
            {/* </div> */}
        </div>
    )
}

export default ExhibitionOverview;